import { opportunityData } from "configs/opportunity.config";
import { states } from "configs/states.config";
import { UseFormReturn } from "react-hook-form";
import { Dropdown, FilePicker, Input, Textarea } from "stories";

export const existingPropertyFields = [
  [
    {
      name: "country",
      component: Dropdown,
      props: {
        label: "Company Country",
        list: opportunityData.companyCountryList,
        disabled: true,
      },
    },
    {
      name: "state_or_province",
      component: Dropdown,
      props: (form: UseFormReturn) => {
        if (!form) {
          return {};
        }
        return {
          label: "State/Province",
          list: form.watch ? states[form.watch("country")] : null,
          disabled: true,
        };
      },
    },
    {
      name: "city",
      component: Input,
      props: {
        label: "City",
        disabled: true,
      },
    },
  ],
  [
    {
      name: "address",
      component: Input,
      props: {
        label: "Street Address",
        disabled: true,
      },
    },
    {
      name: "postal_code",
      component: Input,
      props: {
        label: "Postal Code / Zip Code",
        disabled: true,
      },
    },
    {
      name: "google_map_url",
      component: Input,
      props: {
        label: "Google Map Location (Link)",
        disabled: true,
      },
    },
  ],
  [
    {
      name: "legal_description",
      component: Input,
      props: {
        label: "Legal Description",
      },
    },
    {
      name: "property_identification_number",
      component: Input,
      props: {
        label: "Property Identification Number",
      },
    },
    {},
  ],
  [
    {
      name: "land_title_document_filename",
      component: FilePicker,
      props: {
        label: "Land Title Document",
        type: "file",
      },
    },
    {},
  ],
  [
    {
      name: "site_plans_filename",
      component: FilePicker,
      props: {
        label: "Site Plans",
        type: "file",
      },
    },
    {
      name: "site_plan_description",
      component: Textarea,
      props: {
        label: "Site Plans Description",
      },
    },
  ],
  [
    {
      name: "current_zoning_specification",
      component: Input,
      props: {
        label: "Current Zoning Specifications",
      },
    },
    {
      name: "site_area",
      component: Input,
      props: {
        label: "Site Area",
        type: "currency",
      },
    },
    {
      name: "gross_buildable_area",
      component: Input,
      props: {
        label: "Gross Buildable Area",
        type: "currency",
      },
    },
  ],
  [
    {
      name: "fsr_far",
      component: Input,
      props: (form: UseFormReturn) => {
        const props: any = {
          label: "FSR/FAR",
          disabled: true,
          value: "-",
        };
        if (!form) return props;
        const [newGrossBuildableArea, siteArea] = form.watch([
          "gross_buildable_area",
          "site_area",
        ]);

        if (!isNaN(parseFloat(siteArea)) && parseFloat(siteArea) > 0) {
          const payload = !isNaN(parseFloat(newGrossBuildableArea))
            ? parseFloat(newGrossBuildableArea)
            : 0;
          props.value = Number((payload / parseFloat(siteArea)).toFixed(2));
        }

        return props;
      },
    },
    {
      name: "gross_floor_area",
      component: Input,
      props: {
        label: "Gross Floor Area (GFA)",
        type: "currency",
      },
    },
    {
      name: "net_floor_area",
      component: Input,
      props: {
        label: "Net Floor Area (NFA)",
        type: "currency",
      },
    },
  ],
];
